import { render, staticRenderFns } from "./TransactionFinished.vue?vue&type=template&id=37521a6f&"
import script from "./TransactionFinished.vue?vue&type=script&lang=js&"
export * from "./TransactionFinished.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports